import {
  AllTokens,
  DecreasingValueArrow,
  IncreasingValueArrow,
} from "../../../../../assets";

interface EventCardToken {
  name: string;
  img: string;
}

interface DateCardProps {
  date: Date;
  name: string;
  tokens?: EventCardToken[];
  changeDirection?: "up" | "down" | "unknown";
  className?: string;
}

export const EventCard = ({
  date,
  name,
  tokens,
  changeDirection = "unknown",
}: DateCardProps) => {
  const renderChangeDirection = () => {
    if (changeDirection === "up") {
      return <IncreasingValueArrow />;
    } else if (changeDirection === "down") {
      return <DecreasingValueArrow />;
    } else if (changeDirection === "unknown") {
      return (
        <div className="flex">
          <IncreasingValueArrow /> <DecreasingValueArrow />
        </div>
      );
    } else {
      return;
    }
  };

  const day = date.toLocaleString("en-US", { day: "2-digit" }); // np. "21"
  const month = date.toLocaleString("en-US", { month: "short" });

  return (
    <div className="flex items-center gap-4 bg-xx-blue-transparent-500-10 px-3 py-4 rounded-xl flex-shrink-0">
      <p className="text-base font-bold text-xx-blue-500">
        {day} <span className="text-xs font-medium">{month}</span>
      </p>
      <p className="text-xs">{name}</p>
      <div className="flex gap-1">
        <div className="flex">
          {tokens && tokens.length > 0 ? (
            tokens.map(({ name, img }, index) => (
              <img
                src={img}
                alt={`${name} token logo`}
                key={name}
                className={`w-5 h-5 ${index > 0 ? "-ml-2" : ""}`}
              />
            ))
          ) : (
            <AllTokens />
          )}
        </div>
        <div className="flex items-center">{renderChangeDirection()}</div>
      </div>
    </div>
  );
};
